import debounce from "lodash/debounce";
import React, { useCallback, useMemo, useState } from "react";
import { useLatest } from "react-use";

interface Props {
  answer: string;
  onChange: (answer: string) => void;
  children: (props: {
    answer: string;
    onChange: (answer: string) => void;
    onBlur: () => void;
  }) => React.ReactNode;
}

function DebouncedAnswer(props: Props) {
  const [answer, setAnswer] = useState(props.answer);
  const onChange = useLatest(props.onChange);

  const updateParentState = useMemo(
    () =>
      debounce((answer: string) => {
        onChange.current(answer);
      }, 3000),
    [onChange],
  );

  const handleChange = useCallback(
    (answer: string) => {
      setAnswer(answer);
      updateParentState(answer);
    },
    [updateParentState],
  );

  const handleBlur = useCallback(() => {
    updateParentState.flush();
  }, [updateParentState]);

  return (
    <>
      {props.children({ answer, onChange: handleChange, onBlur: handleBlur })}
    </>
  );
}

export default DebouncedAnswer;
